import { request } from "@/utils/remoteRequest";
// 上传照片,目前没有调用该方法，直接调接口
export function uploadPicture(data) {
  return request({
    url: "/resumeInfo/uploadPicture",
    method: "post",
    data,
  });
}

// 加载照片
export function downloadEmployeeImage(data) {
  return request({
    url: "/resumeInfo/downloadEmployeeImage",
    method: "post",
    data,
  });
}

// 删除附件
export function deleteFileById(data) {
  return request({
    url: "/comm/file/remove",
    method: "post",
    data,
  });
}

// 上传附件,目前没有调用该方法，直接调接口
export function uploadFile(data) {
  return request({
    url: "/resumeInfo/uploadFile",
    method: "post",
    data,
  });
}

// 下载附件
export function downloadFile(data) {
  return request({
    url: "/resumeInfo/downloadFile",
    method: "post",
    data,
  });
}
